// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from "bootstrap-vue"
import App from './App'

import moment from 'moment'
import Loading from 'vue-loading-overlay';
import JsonExcel from 'vue-json-excel'
import 'vue-loading-overlay/dist/vue-loading.min.css';import router from './router'


import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(Loading)
Vue.use(BootstrapVue)
Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = true

// This is a global mixin, it is applied to every vue instance
Vue.mixin({
  data: function() {
    return {
      get urlAPI() {
        window.urlAPI = (Vue.config.productionTip) ? 'https://map.bepsa.net' : 'http://localhost:37200';
        window.localStorage.setItem('urlBepsaMap', window.urlAPI);
        return (Vue.config.productionTip) ? 'https://map.bepsa.net' : 'http://localhost:37200';
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js